var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "profile-list" } },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-cogs" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("profile.titles.list")))]),
      ]),
      _vm._v(" "),
      _c(
        "UiCard",
        [
          _c("SuperTable", {
            ref: "tableIdentifications",
            attrs: { tableColumns: _vm.tableColumns, tableData: _vm.tableData },
            on: {
              sort: _vm.handleSort,
              filter: _vm.handleFilter,
              copy: _vm.handleCopy,
              delete: _vm.handleDelete,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("Toolbar", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "Btn",
                {
                  directives: [
                    {
                      name: "can",
                      rawName: "v-can",
                      value: "beepiz-add-profiles",
                      expression: "'beepiz-add-profiles'",
                    },
                  ],
                  staticClass: "default",
                  attrs: { to: "/configurations/profiles/new" },
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("profile.btns.add")))]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col center" },
            [
              _c("Pagination", {
                ref: "pagination",
                on: { change: _vm.handlePagination },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col" }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }